angular.module("ainapp")
    .controller("favMenuController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            //            $scope.PageName = "Tickets";
            //            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            //            if ($scope.TokenInfo == null) {
            //                $state.go("login");
            //            } else {
            //                $scope.checkUserPageAccess($scope.PageName);
            //            }


            $scope.Init = function () {

                $scope.SelectedFav = {};
                $scope.Favs = [];
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.FavouritesByUserGroup().then(function (response) {
                    if (response.data) {
                        $scope.Favs = response.data;
                        $scope.SelectedFav = $scope.Favs[0];
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                })


            }
            $scope.Init();

            $scope.selectFav = function (data) {
                $scope.SelectedFav = data;
            }


                }])
